import React, { useEffect, useState,useRef, useContext } from "react";
import "../components/css/newsletter.css";
import { useNavigate } from "react-router-dom";
import searchIcon from "../images/search-26233.png";
import tekst from "../images/Tekst_img.png";
import picture from "../images/Picture_img.png";
import movie from "../images/Film_img.png";
import movie2 from "../images/film_img1.png";
import trailer from "../images/Trailer_img.png";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import upload from '../images/upload_on_cloud.png'
import deleteIcon  from  '../images/delete.png'
import { keyContext } from "../components/KeyContext";
import NewsletterEditing from "../components/NewsletterEditing";

function CreateNewsletter() {
  const {setExistingNewsletter,newsletterOrg,saveBtnShown, setSaveBtnShown,newsletterName, setNewsletterName} = useContext(keyContext)
  const key = sessionStorage.getItem("key");
  const navigate = useNavigate();
  const [bios, setBios] = useState([{}]);
  const [chosenBio, setchosenBio] = useState(sessionStorage.getItem('newsletter_bio') ? sessionStorage.getItem('newsletter_bio') : '');
  const [templateLists, setTemplateLists] = useState([{}]);
  // const [selectedMovie, setSelectedMovie] = useState("");
  const [selected, setSelected] = useState(bios);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [newsletterNo, setNewsletterNo] = useState();
  const [orgID, setOrgID] = useState('')
  
  const [chosenTemplate, setChosenTemplate] = useState();
  const [templateNo, setTemplateNo] = useState();
  const [templateItemNo, setTemplateItemNo] = useState();
 
  const [noBio, setNoBio] = useState(false);
 
   let ge = sessionStorage.getItem('newsletter_bio')
   let news_orgs = ge?.split(" ")[ge.split(" ").length - 1]
  

     useEffect(() => {   
     if(sessionStorage.getItem('newsletter_bio')) {
      let ge = sessionStorage.getItem('newsletter_bio')
      setOrgID(ge.split(" ")[ge.split(" ").length - 1])
   
     }
  }, []);

  useEffect(() => {
    if(bios.length === 1) {
       setOrgID(bios[0].No)
      
    }
  }, [bios]);

  useEffect(() => {
    setChosenTemplate(templateLists[0]?.html)
  }, [templateLists]);

    // call for all EXISTING templates
//  useEffect(() => {
//     if(key && orgID) { 

//     const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_get?Key=${key}&OrgNo=${orgID}`;
//      fetch(endpoint, {
//         method: "GET",
//         headers: {
//           ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
//         },
      
//       })
//       .then(res => {    
//        return res.json()
//       })
//       .then(result => {
//         setExistingNewsletter(result)
       
      
//       })
//        }
//   }, [key,orgID]);


// call to fetch templates
 
useEffect(() => {
    if(key && (orgID || news_orgs) ) { 

    const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_templates_get?Key=${key}&OrgNo=${news_orgs?news_orgs:orgID}`;
     fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then(result => {
        setTemplateLists(result)
       
      })
       }
  }, [key,orgID,news_orgs]);



  useEffect(() => {
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
    if (key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
        .then((res) => {
          if (res.status !== 200) {
            navigate("/");
          }
          return res.json();
        })
        .then((result) => {        
          setBios(result);  
          if (result.length === 1) {
          }
          
        });
    }
  }, [key]);



  const handleSelect = (e) => {
     let g = e.target.value;
    setchosenBio(e.target.value);
    setOrgID(g.split(" ")[g.split(" ").length - 1]);
    setSelected(e.target.value);
     sessionStorage.setItem('newsletter_bio',e.target.value)
     setNoBio(false)
  };

  function handleTemplateSelect (e) {
    let selected_tmp = e.target.value
   setChosenTemplate(templateLists.filter((tmp) =>  { return tmp.Name === selected_tmp })[0].html)
 
    setSelectedTemplate(e.target.value)
    setTemplateNo(templateLists.filter((tmp) =>  { return tmp.Name === selected_tmp })[0].No)
  }

    const iframeRef = useRef(null);

  useEffect(() => { 
    setTemplateNo(templateLists[0]?.No)
  }, [templateLists]);

  // const [newsletterName, setNewsletterName] = useState('');
  const  [noName, setNoName] = useState(false);

  function handleNewsletterName (e) {
    setNewsletterName(e.target.value)
    setNoName(false)
  }

 
  function createNewsletter () {
   
   if(newsletterName === '') setNoName(true)
    
    if(!chosenBio)  setNoBio(true)
 
     if(newsletterName && templateNo) {
      const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_create?Key=${key}&OrgNo=${news_orgs? news_orgs : orgID}&TemplateNo=${templateNo}&strName=${newsletterName}&strSubject=${newsletterName} `;
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },     
      })
      .then(res => {    
       return res.json()
      })
      .then(result => {         
             setSaveBtnShown(false)
             setNewsletterNo(result.No)
      })
     }

  }

    const svg = ` <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>`



  return (
    <main className="CreateNewsletter">
  
  
      <section className="newsletterHead">
        <p className="newsletter_title">Opret nyhedsbreve</p>
        {/* <button className="cancel_create">Annuller oprettelse</button> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
            width: "100%",
          }}
        >
          <div>
            <p className="newsletter_label">Navn på nyhedsbrev</p>
            <input
              className="newsletter_input"
              style={{ width: "248px" ,marginTop:'9px',border:noName === true ? '1px solid red' : ''
              }}
              type="text" value={newsletterName} onChange={(e)=>handleNewsletterName(e)}
            />
          </div>
          {/* <div>{selectedMovie ? selectedMovie : selected}</div> */}
          <div>
            <p className="newsletter_label">Vælg biograf</p>
        
            
            <form
              // className=" text-truncate"
              style={{ width: "248px", backgroundColor: "#f7f7f7",marginTop:'9px' }}
            >
              <div className="movieListBox" style={{ width: "248px" }}>
                <span
                  className="select-line"
                  style={{ backgroundColor: "#8d8d8d" }}
                ></span>

                <select
                  className="form-select text-truncate"
                  onChange={handleSelect}
                  value={chosenBio}
                  style={{
                    height: "40px",
                    border:noBio === true ? '1px solid red' : "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    width: "248px",
                    backgroundColor: "#f7f7f7",
                    backgroundImage:  `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,
                    color:'#46484c'
                  }}
                >
                  {bios &&
                    bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            // maxWidth: '200px',
                            marginLeft: "10px",
                            fontSize: "16px",
                              width:'100%',
                              whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
                          }}
                        >
                          {item.City} - {item.Name}
                        </option>
                      );
                    })}
                </select>
              </div>
            </form>
          </div>

          <div>
            <p className="newsletter_label">Vælg skabelon</p>
            <form
              className="form "
              style={{ width: "260px", backgroundColor: "#f7f7f7",marginTop:'9px' }}
            >
              <div className="movieListBox" style={{ width: "260px" }}>
                <span
                  className="select-line"
                  style={{ backgroundColor: "#8d8d8d" }}
                ></span>

                <select
                  className="form-select text-truncate"
                   onChange={handleTemplateSelect}
                  value={selectedTemplate}
                  style={{
                    height: "40px",
                    border:noBio === true ? '1px solid red' : "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    width: "260px",
                    backgroundColor: "#f7f7f7",
                    backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,
                  }}
                >
           {templateLists.length && templateLists?.sort((a,b) => a.Name > b.Name ? 1 : -1).map((item) => {
                
                return (
                  <option key={item.id} id={item.No} value={item.Name} className="text-truncate"  style={{
                    maxWidth: 200,
                    marginLeft: '10px',
                    fontSize: "16px",                   
                  }}>
                    {item.Name}
                  </option>
                );
              })}
                </select>
              </div>
            </form>{" "}
          </div>
          <div>
            <p className="newsletter_label"></p>
            {saveBtnShown === true ?  
            <button onClick={createNewsletter} className="newsletter_savbtn" style={{marginTop:'36px'}}>GEM I 'IKKE UDSENDTE'</button> : ''}
          </div>
        </div>
      </section>
      <hr style={{ height: "3px", margin: 0 ,width:'100.1%'}}></hr>
      { orgID || news_orgs ?  <NewsletterEditing iframeRef={iframeRef} chosenTemplate={chosenTemplate} orgID={orgID} setChosenTemplate={setChosenTemplate} saveBtnShown={saveBtnShown} newsletterNo={newsletterNo} newsletterTemplateNo={templateNo}/>
      : null }
    </main>
  );
}

export default CreateNewsletter;
